import React from "react";
import "react-multi-carousel/lib/styles.css";
import Carousel from "react-multi-carousel";
// import { Image } from "semantic-ui-react";
import Mallimg1 from "./img1.jpg";
import Mallimg4 from "./img4.png";
// import Mallimg3  from './img3.jpg';
import Mallimg5 from "./img5.png";
import Mallimg6 from "./img6.png";
import Mallimg7 from "./img7.png";
import Mallimg8 from "./img8.jpg";
import Mallimg9 from "./img9.jpg";
import Mallimg10 from "./img10.jpg";

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 2,
    paritialVisibilityGutter: 30,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
    paritialVisibilityGutter: 50,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    paritialVisibilityGutter: 30,
  },
};

// const images = [

//   "https://images.unsplash.com/photo-1549396535-c11d5c55b9df?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=60",

//   "https://images.unsplash.com/photo-1550133730-695473e544be?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60",
//   "https://images.unsplash.com/photo-1550167164-1b67c2be3973?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60",
//   "https://images.unsplash.com/photo-1550338861-b7cfeaf8ffd8?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60",
//   "https://images.unsplash.com/photo-1550223640-23097fc71cb2?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60",
//   "https://images.unsplash.com/photo-1550353175-a3611868086b?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60",
//   "https://images.unsplash.com/photo-1550330039-a54e15ed9d33?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60",
//   "https://images.unsplash.com/photo-1549737328-8b9f3252b927?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60",
//   "https://images.unsplash.com/photo-1549833284-6a7df91c1f65?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60",
//   "https://images.unsplash.com/photo-1549985908-597a09ef0a7c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60",
//   "https://images.unsplash.com/photo-1550064824-8f993041ffd3?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60"
// ];

// Because this is an inframe, so the SSR mode doesn't not do well here.
// It will work on real devices.
const Simple = ({ deviceType }) => {
  return (
    <div>
      <div className='text-center py-20 '>
        <h2 className='lh-base fw-bolder fs-2x fs-lg-3x mb-4'>
          Ebonyi Mall Now Letting
        </h2>
        <p>
          The magnificent Ebonyi Mall with dubai standard modern day facility is
          now open and letting. <br></br>Grab this rare opportunity to own your
          own space now.
        </p>
      </div>
      <div></div>
      <Carousel
        ssr
        // partialVisbile
        deviceType={deviceType}
        itemClass='image-item'
        responsive={responsive}
      >
        <div className='image-container increase-size'>
          <div className='image-container-text'></div>
          <img
            draggable={false}
            style={{ width: "100%", cursor: "pointer" }}
            src={Mallimg1}
            alt='img3rd'
          />
        </div>

        <div className='image-container increase-size'>
          <div className='image-container-text'></div>
          <img
            draggable={false}
            style={{ width: "100%", cursor: "pointer" }}
            src={Mallimg4}
            alt='img3rd'
          />
        </div>

        <div className='image-container increase-size'>
          <div className='image-container-text'></div>
          <img
            draggable={false}
            style={{ width: "100%", cursor: "pointer" }}
            src={Mallimg5}
            alt='img3rd'
          />
        </div>

        <div className='increase-size'>
          <div className='image-container-text'></div>
          <img
            draggable={false}
            style={{ width: "100%", cursor: "pointer" }}
            src={Mallimg6}
            alt='img3rd'
          />
        </div>

        <div className='increase-size'>
          <div className='image-container-text'></div>
          <img
            draggable={false}
            style={{ width: "100%", cursor: "pointer" }}
            src={Mallimg7}
            alt='img3rd'
          />
        </div>

        <div className='increase-size'>
          <div className='image-container-text'></div>
          <img
            draggable={false}
            style={{ width: "100%", cursor: "pointer" }}
            src={Mallimg8}
            alt='img3rd'
          />
        </div>

        <div className='increase-size'>
          <div className='image-container-text'></div>
          <img
            draggable={false}
            style={{ width: "100%", cursor: "pointer" }}
            src={Mallimg9}
            alt='img3rd'
          />
        </div>

        <div className='increase-size'>
          <div className='image-container-text'></div>
          <img
            draggable={false}
            style={{ width: "100%", cursor: "pointer" }}
            src={Mallimg10}
            alt='img3rd'
          />
        </div>
      </Carousel>

      <div className='py-8'>
        <button
          className='btn btn-secondary'
          data-bs-toggle='modal'
          data-bs-target='#exampleModal'
        >
          Request A Quote
        </button>

        <div
          className='modal fade'
          id='exampleModal'
          tabindex='-1'
          aria-labelledby='exampleModalLabel'
          aria-hidden='true'
        >
          <div className='modal-dialog modal-dialog-centered'>
            <div className='modal-content'>
              <div className='modal-header'>
                <h5 className='modal-title' id='exampleModalLabel'>
                  Contact Us
                </h5>
                <button
                  type='button'
                  class='btn-close'
                  data-bs-dismiss='modal'
                  aria-label='Close'
                ></button>
              </div>
              <div className='modal-body'>
                <h6>Email Us:</h6>
                <p>info@3rdretailafrica.com</p>
                <h6>Call Us:</h6>
                <p>
                  +234 9099 359 967 <strong>or</strong> +234 9060 002 731
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Simple;
